import { render, staticRenderFns } from "./KanbanStageSelect.vue?vue&type=template&id=63e7dc08&scoped=true&"
import script from "./KanbanStageSelect.vue?vue&type=script&lang=js&"
export * from "./KanbanStageSelect.vue?vue&type=script&lang=js&"
import style0 from "./KanbanStageSelect.vue?vue&type=style&index=0&id=63e7dc08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7dc08",
  null
  
)

export default component.exports